export const PAYMENT_METHOD_NAME = 'budpay';
export const PAYMENT_METHOD_VERSION = '1.0.0';